import React from 'react';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const InteractiveQRCode = ({ imageSrc, altText, verifyUrl, qrIcon, qrPosition = 'top-left' }) => {

    const { t } = useTranslation();
    
    // Position the QR code. We add a 12px margin so it looks like a natural watermark, 
    // but you can change these to '0' if you want it exactly flush against the edge.
    const positioning = qrPosition === 'top-left' 
        ? { top: '12px', left: '12px' } 
        : { top: '12px', right: '12px' };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
            <div style={{ position: 'relative', display: 'inline-block', lineHeight: 0 }}>
                
                {/* Base Image - NO border radius as requested */}
                <img 
                    src={imageSrc} 
                    alt={altText || "QR Code Demo"} 
                    style={{ 
                        maxWidth: '100%', 
                        maxHeight: '350px', 
                        width: 'auto', 
                        height: 'auto', 
                        display: 'block',
                        borderRadius: '0px' // Explicitly 0
                    }}
                />

                {/* Clickable QR Code Overlay */}
                <Tooltip
                    placement={qrPosition === 'top-left' ? 'right' : 'left'}
                    arrow
                    componentsProps={{
                        tooltip: { 
                            sx: { 
                                backgroundColor: '#171F29', 
                                opacity: '1 !important',
                                boxShadow: '0 8px 32px rgba(0,0,0,0.9)', 
                                padding: '10px 14px',
                                border: '1px solid rgba(255,255,255,0.1)'
                            } 
                        },
                        arrow: { 
                            sx: { color: '#171F29', opacity: '1 !important' } 
                        }
                    }}
                    title={
                        <div style={{ color: 'white', fontSize: '0.75rem', fontWeight: 600, fontFamily: 'Roboto, sans-serif', letterSpacing: '0.5px' }}>
                            {t('industryApplications.interactive.textHighlight.verifyTooltip')}
                        </div>
                    }
                >
                    <img 
                        src={qrIcon}
                        alt="Verification QR Code"
                        onClick={() => window.open(verifyUrl || 'https://www.vetra-ai.com/', '_blank')}
                        style={{
                            position: 'absolute',
                            ...positioning,
                            width: '55px', // Standard QR code size
                            height: '55px',
                            cursor: 'pointer',
                            backgroundColor: 'white', // Ensure QR has a white background
                            border: '2px solid white', // Create a clean white frame
                            boxShadow: '0 4px 15px rgba(0,0,0,0.6)',
                            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                            zIndex: 10
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.8)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.6)';
                        }}
                    />
                </Tooltip>
            </div>
        </div>
    );
};

export default InteractiveQRCode;